function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M32.3683 122.399H267.217C260.247 122.312 253.564 119.607 248.497 114.82C243.43 110.032 240.349 103.514 239.868 96.5595L235.713 26.5642H0.879883L5.01854 96.5595C5.50012 103.514 8.58062 110.032 13.6478 114.82C18.715 119.607 25.3979 122.312 32.3683 122.399Z",
  fill: "#407BFF"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.6,
  d: "M32.3683 122.399H267.217C260.247 122.312 253.564 119.607 248.497 114.82C243.43 110.032 240.349 103.514 239.868 96.5595L235.713 26.5642H0.879883L5.01854 96.5595C5.50012 103.514 8.58062 110.032 13.6478 114.82C18.715 119.607 25.3979 122.312 32.3683 122.399Z",
  fill: "white"
});
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M284.622 -19.9978H75.5651C72.2323 -20.0371 68.9276 -19.384 65.8604 -18.0799C62.7931 -16.7757 60.03 -14.8489 57.7461 -12.4215C55.4621 -9.99406 53.7071 -7.11883 52.592 -3.97789C51.4769 -0.836949 51.0261 2.5013 51.2681 5.82551L56.6814 96.577C56.9283 99.9023 56.4809 103.243 55.3676 106.386C54.2543 109.529 52.4994 112.406 50.2145 114.834C47.9295 117.263 45.1645 119.189 42.095 120.492C39.0255 121.795 35.7187 122.444 32.3845 122.4H267.218C270.552 122.444 273.859 121.795 276.928 120.492C279.998 119.189 282.763 117.263 285.048 114.834C287.333 112.406 289.088 109.529 290.201 106.386C291.314 103.243 291.762 99.9023 291.515 96.577L292.097 106.396L286.149 5.88844C285.893 2.55812 286.333 -0.789012 287.443 -3.93962C288.552 -7.09022 290.305 -9.97518 292.591 -12.4106C294.877 -14.846 297.645 -16.7785 300.719 -18.0848C303.793 -19.3911 307.106 -20.0426 310.446 -19.9978H284.622Z",
  fill: "#407BFF"
});
var _ref5 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M310.445 -19.9973H75.5641C82.5342 -19.9188 89.219 -17.2179 94.2873 -12.4324C99.3557 -7.64696 102.436 -1.12809 102.914 5.82602L123.135 346.817H357.968L337.794 5.88896C337.324 -1.07376 334.249 -7.60392 329.18 -12.4011C324.112 -17.1982 317.423 -19.9103 310.445 -19.9973Z",
  fill: "#407BFF"
});
var _ref6 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.8,
  d: "M310.445 -19.9973H75.5641C82.5342 -19.9188 89.219 -17.2179 94.2873 -12.4324C99.3557 -7.64696 102.436 -1.12809 102.914 5.82602L123.135 346.817H357.968L337.794 5.88896C337.324 -1.07376 334.249 -7.60392 329.18 -12.4011C324.112 -17.1982 317.423 -19.9103 310.445 -19.9973Z",
  fill: "white"
});
var _ref7 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M182.037 77.0638H138.51L135.882 33.5056H179.425L182.037 77.0638ZM143.231 71.9338H176.545L174.704 38.6199H141.327L143.231 71.9338Z",
  fill: "white"
});
var _ref8 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M188.111 179.523H144.537L141.957 135.949H185.53L188.111 179.523ZM149.353 174.393H182.666L180.699 141.079H147.386L149.353 174.393Z",
  fill: "white"
});
var _ref9 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M303.489 33.4895H203.311V38.6195H303.489V33.4895Z",
  fill: "white"
});
var _ref10 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M292.853 52.7205H204.446V57.8505H292.853V52.7205Z",
  fill: "white"
});
var _ref11 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M305.756 71.9336H205.579V77.0636H305.756V71.9336Z",
  fill: "white"
});
var _ref12 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M309.548 135.949H209.371V141.079H309.548V135.949Z",
  fill: "white"
});
var _ref13 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M269.311 155.178H210.504V160.309H269.311V155.178Z",
  fill: "white"
});
var _ref14 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M242.007 174.393H211.652V179.523H242.007V174.393Z",
  fill: "white"
});
var _ref15 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M311.83 174.393H261.741V179.523H311.83V174.393Z",
  fill: "white"
});
var _ref16 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M163.106 66.8034C162.017 66.8046 160.969 66.3877 160.179 65.6389L149.525 55.5361C149.118 55.1507 148.791 54.6889 148.562 54.177C148.334 53.6652 148.208 53.1133 148.193 52.5529C148.162 51.4211 148.582 50.3234 149.36 49.5012C150.138 48.679 151.211 48.1998 152.343 48.1688C153.475 48.1378 154.573 48.5576 155.395 49.336L162.98 56.496L180.054 38.352C180.83 37.5278 181.902 37.0456 183.034 37.0117C184.165 36.9777 185.264 37.3948 186.089 38.1711C186.913 38.9473 187.395 40.0193 187.429 41.151C187.463 42.2828 187.046 43.3817 186.27 44.206L166.269 65.4658C165.885 65.8776 165.423 66.2082 164.909 66.4379C164.396 66.6677 163.841 66.792 163.279 66.8034H163.106Z",
  fill: "#407BFF"
});
var _ref17 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M169.179 169.264C168.089 169.268 167.041 168.851 166.252 168.099L155.551 157.996C155.13 157.616 154.789 157.155 154.548 156.64C154.307 156.126 154.171 155.569 154.148 155.001C154.126 154.434 154.217 153.867 154.416 153.335C154.615 152.803 154.919 152.317 155.309 151.904C155.699 151.491 156.167 151.16 156.687 150.93C157.206 150.701 157.766 150.578 158.334 150.568C158.902 150.558 159.466 150.661 159.994 150.872C160.521 151.083 161.001 151.397 161.405 151.796L169.006 158.956L186.064 140.812C186.84 139.988 187.912 139.506 189.044 139.472C190.176 139.438 191.275 139.855 192.099 140.631C192.923 141.408 193.405 142.479 193.439 143.611C193.473 144.743 193.056 145.842 192.28 146.666L172.279 167.926C171.898 168.337 171.438 168.667 170.928 168.896C170.417 169.126 169.865 169.251 169.305 169.264H169.179Z",
  fill: "#407BFF"
});
const SvgCompleteList = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 176,
    viewBox: "0 0 358 176",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompleteList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/complete-list.514668d2.svg";
export { ForwardRef as ReactComponent };